import { render, staticRenderFns } from "./videoTutorialList.vue?vue&type=template&id=4c5d4c80&"
import script from "./videoTutorialList.vue?vue&type=script&lang=js&"
export * from "./videoTutorialList.vue?vue&type=script&lang=js&"
import style0 from "./videoTutorialList.vue?vue&type=style&index=0&id=4c5d4c80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports